// shortcut.service.ts
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ShortcutService {
    public triggerAddPatient$ = new Subject<void>();
    constructor(private router: Router) { }

    handleShortcut(event: KeyboardEvent, isFromDashboard) {
        let loginMenuList = JSON.parse(localStorage.getItem("moduleList") || '[]');
        let moduleMenuList = JSON.parse(localStorage.getItem("moduleMenuList") || '[]');
        if (event.ctrlKey && event.altKey && event.key.toLowerCase() === 'ṇ') {
      this.triggerAddPatient$.next();
      return;
    }
    if (event.ctrlKey && event.altKey && event.key.toLowerCase() === 'ṇ') {
        event.preventDefault();
      this.triggerAddPatient$.next();
      return;
    }
        if (isFromDashboard || !isFromDashboard && event.altKey) {
            for (const element of loginMenuList) {
                for (const menulist of element.menuList) {
                    for (const list of menulist.list) {
                        if (event.altKey && event.key.toLowerCase() === list.shortCutKey.toLowerCase()) {
                            let childModuleList = list.children.length > 0 ? list.children[0] : [];
                            if (childModuleList.children.length > 0) {
                                event.preventDefault();
                                this.router.navigate([list.parent + "/" + childModuleList.location + "/" + childModuleList.children[0].location]);
                            } else {
                                event.preventDefault();
                                this.router.navigate([list.parent + "/" + childModuleList.location]);
                            }
                            return;
                        }
                    }
                }
            }
        }
        if (!isFromDashboard && event.ctrlKey) {
            const path = this.router.url;
            const moduleName = path.split('/')[1];
            
            for (const menuElement of moduleMenuList) {
                if (menuElement.children && menuElement.children.length > 0) {
                    for (const childMenuElement of menuElement.children) {
                        const result = childMenuElement['shortCutKey'] ? childMenuElement['shortCutKey'].toLowerCase() : '';
                        if (event.ctrlKey && event.key.toLowerCase() === result) {
                            event.preventDefault();
                            this.router.navigate([moduleName + '/' + menuElement.location + '/' + childMenuElement.location]);
                            return;
                        }
                    }
                } else {
                    const result = menuElement['shortCutKey'] ? menuElement['shortCutKey'].toLowerCase() : '';
                    if (event.ctrlKey && event.key.toLowerCase() === result) {
                        event.preventDefault();
                        this.router.navigate([moduleName + '/' + menuElement.location]);
                        return;
                    }
                }
            }
        }
    }

}
